import { render } from "./AppsOverviewComponent.vue?vue&type=template&id=b4a7681e&scoped=true"
import script from "./AppsOverviewComponent.vue?vue&type=script&lang=js"
export * from "./AppsOverviewComponent.vue?vue&type=script&lang=js"

import "./AppsOverviewComponent.vue?vue&type=style&index=0&id=b4a7681e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4a7681e"]])

export default __exports__